import React, { useState } from "react";
import styled, { css } from "styled-components";
import CaretIcon from "sweet-web/components/icons/CaretIcon";
import Input from "sweet-web/components/universal/Input";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";
import { globalInputStyles } from "./index";

/*
Select Input
Select from a number of options
*/

const Wrapper = styled.div`
  position: relative;
  width: auto;
  padding: 10px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Select = styled.select`
  ${globalInputStyles}
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  padding-right: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: ${props => (Boolean(props.value) ? colors.nearBlack : colors.gray)};
  &:hover,
  &:focus {
    color: ${colors.nearBlack};
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  width: 100%;
`;

type Props = {
  title?: string;
  description?: string;
  value: string;
  options: Array<{
    title: string;
    name: string;
  }>;
  onChange: (value: string) => void;
  style?: object;
};
const SelectInput: React.FC<Props> = props => {
  return (
    <Wrapper style={props.style}>
      {props.title && <ItemTitle>{props.title}</ItemTitle>}
      {props.description && <ItemLabel>{props.description}</ItemLabel>}
      <SelectWrapper>
        <Select
          value={props.value ? props.value : ""}
          onChange={e => {
            const value = e.target.value;
            props.onChange(value);
          }}
        >
          {props.options.map(option => (
            <option
              key={`option-${option.title}-${option.name}`}
              value={option.name}
            >
              {option.title}
            </option>
          ))}
        </Select>
        <CaretIcon
          size={14}
          style={{
            position: "absolute",
            right: 15,
            bottom: 6,
            transform: "rotate(90deg)",
            pointerEvents: "none"
          }}
          color={colors.gray}
        />
      </SelectWrapper>
    </Wrapper>
  );
};
SelectInput.defaultProps = {
  style: {}
};

export default SelectInput;
